import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccessFill = props => {
  if (props.id !== "_svgsuccessfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 2.4c-5.302 0-9.6 4.298-9.6 9.6a9.6 9.6 0 1019.2 0A9.6 9.6 0 0012 2.4zm-1.454 10.653l5.818-5.819 1.94 1.94-7.758 7.758-4.85-4.849 1.94-1.94 2.91 2.91z" fill="#01803F" /></svg>;
};

SvgSuccessFill.displayName = "_svgsuccessfill";
SvgSuccessFill.propTypes = {
  id: PropTypes.string
};
SvgSuccessFill.defaultProps = {
  id: ''
};
export default SvgSuccessFill;